import { createAction, props } from '@ngrx/store';
import {
  BrainEstreamComputeRangeRequest,
  BrainEstreamComputeRangeResponse,
} from 'brain-data/model/brain-estream-compute-range.model';

export const loadEstreamComputeRange = createAction(
  '[EstreamComputeRange] load',
  props<{ request: BrainEstreamComputeRangeRequest }>(),
);

export const loadEstreamComputeRangeSuccess = createAction(
  '[EstreamComputeRange] load success',
  props<{
    request: BrainEstreamComputeRangeRequest;
    response: BrainEstreamComputeRangeResponse;
  }>(),
);

export const loadEstreamComputeRangeError = createAction(
  '[EstreamComputeRange] load error',
  props<{ request: BrainEstreamComputeRangeRequest; error: Error }>(),
);

export const estreamComputeRangeCacheKey = (
  request: BrainEstreamComputeRangeRequest,
): string =>
  `${request.contractNumber.trim()}|${request.startMonth}|${request.endMonth}`;
